import { ui } from '../ui';
import { colors } from '../theme';
import { SPARK_TYPE_LABEL } from '../sparkTypeLabels';

function fmt(str) {
  return new Date(str).toLocaleString('ru', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}

/** История начислений/списаний искр текущей анкеты — переиспользуется в Applications.js
 * (админ) и Clients.js (куратор), по аналогии с MatchesBlock. */
export default function SparkTransactionsBlock({ transactions }) {
  return (
    <div style={ui.card}>
      <div style={{ fontWeight: 600, marginBottom: 12 }}>История искр {transactions.length > 0 ? `(${transactions.length})` : ''}</div>
      {transactions.length === 0 ? (
        <div style={ui.empty}>Транзакций пока нет</div>
      ) : (
        transactions.map(t => (
          <div
            key={t.id}
            style={{
              display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12,
              padding: '10px 0', borderBottom: `1px solid ${colors.border}`,
            }}
          >
            <span>
              <span style={{ fontWeight: 600, color: t.amount > 0 ? colors.good : colors.danger }}>
                {t.amount > 0 ? `+${t.amount}` : t.amount}
              </span>{' '}
              {SPARK_TYPE_LABEL[t.type] || t.type}
              {t.reference && <span style={{ color: colors.textMuted }}> ({t.reference})</span>}
            </span>
            <span style={{ color: colors.textMuted, fontSize: 12 }}>{fmt(t.created_at)}</span>
          </div>
        ))
      )}
    </div>
  );
}
